module.exports = __webpack_public_path__ + "static/media/R2.d46ec681.jpg";